export default "__VITE_ASSET__Xp1_e68Q__";